import axios from 'axios'
import store from '../store'
import router from '../router'
import { translateApiMsg } from './apiMsg'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
request.interceptors.request.use(
  config => {
    const token = store.state.token
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    const locale = store.state.locale
    if (locale) {
      config.headers['Accept-Language'] = locale
    }
    // FormData 自动设置 Content-Type（包含 boundary）
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type']
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  response => {
    const res = response.data
    // 后端 msg 统一为中文，这里按当前语言翻译，页面直接用 res.msg 就是本地化文案
    if (res && typeof res.msg === 'string' && res.msg) {
      res.msg = translateApiMsg(res.msg)
    }
    // 检查业务状态码：未登录则跳转登录页
    if (res && res.code === 401) {
      store.commit('LOGOUT')
      if (router.currentRoute.path !== '/login') {
        router.push({ name: 'Login', query: { redirect: router.currentRoute.fullPath } })
      }
      return Promise.reject(new Error(res.msg || translateApiMsg('未登录')))
    }
    return res
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit('LOGOUT')
          if (router.currentRoute.path !== '/login') {
            router.push({ name: 'Login', query: { redirect: router.currentRoute.fullPath } })
          }
          break
        case 403:
          console.error('没有权限访问')
          break
        case 404:
          console.error('请求的资源不存在')
          break
        case 500:
          console.error('服务器错误')
          break
        default:
          console.error('请求失败:', error.response.status)
      }
    } else if (error.request) {
      console.error('网络错误，请检查网络连接')
    }
    return Promise.reject(error)
  }
)

export default request
